/**
 * supplierFeeHelpers.ts
 * 협력사 수수료 관리 관련 유틸리티 함수 모음
 */

// 수수료 구분 옵션
export const COMMISSION_TYPE_OPTIONS = [
    { value: '', label: '선택' },
    { value: 'PER_CASE_FIXED', label: '건당 정액' },
    { value: 'PER_CASE_RATE', label: '건당 정률' },
    { value: 'PER_DAY_FIXED', label: '1일 정액' },
    { value: 'PER_DAY_RATE', label: '1일 정률' }
] as const;

// 라이더 상태 필터 옵션
export const STATUS_FILTER_OPTIONS = [
    { value: '', label: '전체' },
    { value: 'UNDER_CONTRACT', label: '계약 중' },
    { value: 'TERMINATED_CONTRACT', label: '계약 종료' },
] as const;

// 페이지네이션 상수
export const ITEMS_PER_PAGE = {
    DEFAULT: 10,
    LARGE: 15,
    EXTRA_LARGE: 20,
} as const;

/**
 * 필터 스토리지 키
 */
export const FILTER_STORAGE_KEY = 'supplierFeeFilters';

/**
 * 수수료 타입에 따른 금액 단위 반환
 * @param commissionType 수수료 구분
 * @returns 단위 문자열 (원 또는 %)
 */
export const getAmountUnit = (commissionType: string): string => {
    if (commissionType.includes('RATE')) {
        return '%';
    }
    return '원';
};

/**
 * 계약 중 여부 확인
 * @param contStatus 계약 상태
 * @returns 계약 중 여부
 */
export const isUnderContract = (contStatus: string): boolean => {
    return contStatus === 'UNDER_CONTRACT';
};

/**
 * 수수료 저장 유효성 검사
 * @param commissionType 수수료 구분
 * @param amount 금액
 * @returns 유효성 검사 결과 객체
 */
export const validateFeeData = (
    commissionType: string,
    amount: string
): { valid: boolean; message: string } => {
    if (!commissionType) {
        return { valid: false, message: '수수료구분을 선택해주세요.' };
    }
    if (!amount) {
        return { valid: false, message: '금액을 입력해주세요.' };
    }
    return { valid: true, message: '' };
};

/**
 * 라이더 수수료 행 데이터 타입
 */
export interface RiderCommissionRow {
    riderId: string;
    riderName: string;
    commissionType: string;
    amount: string;
    applyDate: string;
    isEdited: boolean;
    contStatus: string;
}

/**
 * 히스토리 아이템 타입
 */
export interface CommissionHistoryItem {
    applyDate: string;
    period?: string;
    commissionType: string;
    amount: number;
    modifier: string;
}
